import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./locales/en";
import nl from "./locales/nl";
import de from "./locales/de";
import fr from "./locales/fr";

const LOCALES = { en, nl, de, fr };

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN", flag: "🇬🇧" },
  { code: "nl", label: "Nederlands", short: "NL", flag: "🇳🇱" },
  { code: "de", label: "Deutsch", short: "DE", flag: "🇩🇪" },
  { code: "fr", label: "Français", short: "FR", flag: "🇫🇷" },
];

const STORAGE_KEY = "nx-lang";

const LangContext = createContext({
  lang: "en",
  setLang: () => {},
  t: en,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && LOCALES[stored]) return stored;
    return "en";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (next) => {
    if (LOCALES[next]) setLangState(next);
  };

  const value = useMemo(
    () => ({ lang, setLang, t: LOCALES[lang] || LOCALES.en }),
    [lang],
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useI18n = () => useContext(LangContext);
export const useT = () => useContext(LangContext).t;
